import React from 'react';

interface SessionRecoveryModalProps {
  email: string;
  businessName?: string;
  onRestore: () => void;
  onStartFresh: () => void;
}

/**
 * Modal shown when a previous registration session is found for the entered email.
 * Extracted from PartyDetails for reusability.
 */
const SessionRecoveryModal: React.FC<SessionRecoveryModalProps> = ({
  email,
  businessName,
  onRestore,
  onStartFresh,
}) => (
  <div
    onClick={(e) => e.stopPropagation()}
    onMouseDown={(e) => e.stopPropagation()}
    data-testid="session-recovery-modal"
    style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      style={{
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 24,
        maxWidth: 450,
        width: '90%',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
      }}
    >
      <h3 style={{ margin: '0 0 16px', fontSize: '1.25rem', color: '#1a1a1a' }}>
        Continue Your Registration?
      </h3>
      <p style={{ margin: '0 0 20px', color: '#666', lineHeight: 1.5 }}>
        We found an existing registration for <strong>{email}</strong>.
        Would you like to continue where you left off?
      </p>
      {businessName && (
        <p style={{
          margin: '0 0 20px',
          padding: 12,
          backgroundColor: '#f5f5f5',
          borderRadius: 8,
          fontSize: '0.9rem',
        }}>
          <strong>Business:</strong> {businessName}
        </p>
      )}
      <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
        <button
          className="btn-secondary"
          data-testid="session-start-fresh-btn"
          onClick={onStartFresh}
          style={{ padding: '10px 20px' }}
        >
          Start Fresh
        </button>
        <button
          className="btn-primary"
          data-testid="session-restore-btn"
          onClick={onRestore}
          style={{ padding: '10px 20px' }}
        >
          Continue Registration
        </button>
      </div>
    </div>
  </div>
);

export default SessionRecoveryModal;
